import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  // Auth
  LoginPage,
  RegisterPage,
  VerifyCodePage,
  NewPasswordPage,
  ResetPasswordPage,
  ForgotPasswordPage,
  AccessSetPasswordPage,

  // DASHBOARD: GENERAL
  HomePage,
  ProductDetailPage,
  UnderConstructionPage,
  Page404,
  PageOne,
  ChartPage,
  HoldingPage,
  HoldingBasePage,

  // DASHBOARD: AI
  AiDashboardPage,
  SetThresholdPage,

  // DASHBOARD: BANK MANAGEMENT
  BankPage,
  BankBenefitCompanyPage,
  BankBenefitPage,
  CurrentBalanceChartPage,
  CurrentBalanceChartCompanyPage,
  AvragePage,
  AvrageTrendPage,
  LoanPage,
  LoanTrendPage,
  WarrPage,
  WarrTrendPage,
  PersenelPage,
  PersenelTrendPage,
  CompanyPage,

  // DASHBOARD: DATA ENTRY
  AccountInfoPage,
  AmountInfoPage,
  LoanInfoPage,
  WarrInfoPage,
  ApprovalsInfoPage,

  // DASHBOARD: USER
  UserRolePage,
  UsersListPage,
  ChangePasswordPage,
  AccessLevelPage,

  // DASHBOARD: SUPPLIER
  SupplierIntroductionPage,

  // DASHBOARD: SHOPPER
  BuyerIntroductionPage,

  // DASHBOARD: BROKER

  // DASHBOARD: GOODS
  GoodsSearchPage,
  PRDMPage,
  LevelPage,

  // DASHBOARD: WAGE

  // DASHBOARD: SUPPLY
  SetSUPMPage,
  UpdateTRDMPage,
  SupplyBoardPage,
  TRDMDetailPage,

  // DASHBOARD: ORDER

  // DASHBOARD: ORDERING
  OrderGeneralListPage,
  OrderListPage,
  OrderGeneralDetailPage,
  OrderDetailPage,
  DepositGeneralListPage,
  DepositListPage,
  DepositConfirmPage,
  DepositRegistrationPage,
  DepositAddPage,
  CheckoutPage,
  RegistrationOrderPage,

  // DASHBOARD: REPORT
  OnlineAccountBalancePage,
  AccountBalancePage,
  AverageReportPage,
  AccountGeneralListPage,
  AccountListPage,

  // DASHBOARD: PRICE
  SupplyGroupPage,

  // DASHBOARD: FINANCIAL
  CifAccountPage,
  DepositManualACCT,

  // DASHBOARD: TRANSPORT
  TransportPage,
  WarrFilePage,
  DepFilePage,
  LoanFilePage,
  MavadDepFilePage,
  MahsoolDepFilePage,
  SellMDepFilePage,
  CIFDepFilePage,
  TaminDepFilePage,
  TrafficRptPage,
  TaradodRptPage,
  VehicleListPage,
  VehicleCatListPage,
  VehicleDPage,
  //

  RegMamaPage,
  TasvibMamaPage,
  TahaghoghMamaPage,
  MamaRptPage,
  MAMADashPage,
  MamaRptEnherafPage,

  //

  AccountAWCPage,
  AccountTAWCPage,
  AccountTRANPage,
  AccountAWCTemplatePage,
  AccountTemplatePage,

  // Mavad
  MavadGeneralPage,
  MavadPage,
  MavadReportPage,
  MavadDeadStockPage,

  TaminkReportPage,
  TaminkPage,
  TaminkAllPage,
  KharidReportPage,

  SellMPage,
  SellAllPage,
  SellTrendPage,
  SellByProductPage,
  SellForecastPage,


  CIFRptPage,
  CifAllPage,
  CifClusterPage,
  CifProfilePage,
  CallRptPage,


  // Tolid

  TolidReportPage,
  TolidGeneralPage,
  TolidTrendPage,
  TolidTafkikPage,

  //

  ProductPage,
  ProductRptPage,
  ProductDPage,
  DeadstockProductsPage,

  //
  GlucAllPage,

  //
  HRRptPage,
  HRProfilePage,

  // DASHBOARD: BASE D
  ProductListPage,

} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },

    // Dashboard
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <HomePage /> },
        { path: 'one', element: <PageOne /> },
        { path: 'chart', element: <ChartPage /> },
        { path: 'brand/:name', element: <ProductDetailPage /> },
        { path: 'underconstruction', element: <UnderConstructionPage /> },
        {
          path: 'AI',
          children: [
            { element: <Navigate to="/dashboard/AI/AiDashboard" replace />, index: true },
            { path: 'AiDashboard', element: <AiDashboardPage /> },
            { path: 'SetThreshold', element: <SetThresholdPage /> },
          ],
        },
        // {
        //   path: 'brand',
        //   children: [
        // { element: <Navigate to="/dashboard/brand" replace />, index: true },
        //     { path: ':name', element: <ProductDetailPage /> },
        //   ],
        // },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/usersList" replace />, index: true },
            { path: 'usersList', element: <UsersListPage /> },
            { path: 'changePassword', element: <ChangePasswordPage /> },
            { path: 'accessSetPassword', element: <AccessSetPasswordPage /> },
            { path: 'userRole', element: <UserRolePage /> },
            { path: 'accessLevel', element: <AccessLevelPage /> },
            { path: 'one', element: <PageOne /> },

          ],
        },
        {
          path: 'HoldingR',
          children: [
            { path: 'Holding', element: <HoldingPage /> },
            { path: 'HoldingBase', element: <HoldingBasePage /> },
          ],
        },
        {
          path: 'UploadF',
          children: [
            { path: 'WarrFile', element: <WarrFilePage /> },
            { path: 'DepFile', element: <DepFilePage /> },
            { path: 'LoanFile', element: <LoanFilePage /> },
          ],
        },
        {
          path: 'depFile',
          children: [
            { element: <Navigate to="/dashboard/depFile/MavadDepFile" replace />, index: true },
            { path: 'MavadDepFile', element: <MavadDepFilePage /> },
            { path: 'MahsoolDepFile', element: <MahsoolDepFilePage /> },
            { path: 'SellMDepFile', element: <SellMDepFilePage /> },
            { path: 'CIFDepFile', element: <CIFDepFilePage /> },
            { path: 'TaminDepFile', element: <TaminDepFilePage /> },
          ],
        },

        {
          path: 'MAMA',
          children: [
            { path: 'regMama', element: <RegMamaPage /> },
            { path: 'tasvibMama', element: <TasvibMamaPage /> },
            { path: 'tahaghoghMama', element: <TahaghoghMamaPage /> },
            { path: 'MamaRpt', element: <MamaRptPage /> },
            { path: 'MAMADash', element: <MAMADashPage /> },
            { path: 'MamaRptEnheraf', element: <MamaRptEnherafPage /> },
          ],
        },


        {
          path: 'TRAN',
          children: [
            { path: 'AccountTemplate', element: <AccountTemplatePage /> },
            { path: 'AccountAWCTemplate', element: <AccountAWCTemplatePage /> },
            { path: 'AccountAWC', element: <AccountAWCPage /> },
            { path: 'AccountTAWC', element: <AccountTAWCPage /> },
            { path: 'AccountTRAN', element: <AccountTRANPage /> },
          ],
        },

        {
          path: 'BankManagement',
          children: [
            { path: 'Bank', element: <BankPage /> },

            { path: 'BankBenefitCompany', element: <BankBenefitCompanyPage /> },
            { path: 'CurrentBalanceChartCompany', element: <CurrentBalanceChartCompanyPage /> },
            { path: 'AvrageTrend', element: <AvrageTrendPage /> },
            { path: 'LoanTrend', element: <LoanTrendPage /> },
            { path: 'WarrTrend', element: <WarrTrendPage /> },
            { path: 'PersenelTrend', element: <PersenelTrendPage /> },
          ],
        },
        {
          path: 'CompanyR',
          children: [
            { path: 'Company', element: <CompanyPage /> },
            { path: 'BankBenefit', element: <BankBenefitPage /> },
            { path: 'CurrentBalanceChart', element: <CurrentBalanceChartPage /> },
            { path: 'Avrage', element: <AvragePage /> },
            { path: 'Loan', element: <LoanPage /> },
            { path: 'Warr', element: <WarrPage /> },
            { path: 'Persenel', element: <PersenelPage /> },
          ],
        },

        {
          path: 'dataEntry',
          children: [
            { path: 'accountInfo', element: <AccountInfoPage /> },
            { path: 'amountInfo', element: <AmountInfoPage /> },
            { path: 'loanInfo', element: <LoanInfoPage /> },
            { path: 'warrInfo', element: <WarrInfoPage /> },
            { path: 'approvalsInfo', element: <ApprovalsInfoPage /> },
          ],
        },

        {
          path: 'supplier',
          children: [
            {
              element: <Navigate to="/dashboard/supplier/supplierIntroduction" replace />,
              index: true,
            },

            { path: 'supplierIntroduction', element: <SupplierIntroductionPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'shopper',
          children: [
            {
              element: <Navigate to="/dashboard/shopper/buyerIntroduction" replace />,
              index: true,
            },
            { path: 'buyerIntroduction', element: <BuyerIntroductionPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'broker',
          children: [
            { element: <Navigate to="/dashboard/broker/one" replace />, index: true },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'goods',
          children: [
            { element: <Navigate to="/dashboard/goods/goodsSearch" replace />, index: true },
            { path: 'goodsSearch', element: <GoodsSearchPage /> },
            { path: 'prdmList', element: <PRDMPage /> },
            { path: 'levelList', element: <LevelPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'wage',
          children: [
            { element: <Navigate to="/dashboard/wage/one" replace />, index: true },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'supply',
          children: [
            { element: <Navigate to="/dashboard/supply/setSUPM" replace />, index: true },
            { path: 'setSUPM', element: <SetSUPMPage /> },
            { path: 'one', element: <PageOne /> },
            { path: 'updateTRDM', element: <UpdateTRDMPage /> },
            { path: ':id/edit', element: <TRDMDetailPage /> },
            { path: 'supplyGroup', element: <SupplyGroupPage /> },
          ],
        },
        {
          path: 'order',
          children: [
            { element: <Navigate to="/dashboard/order/one" replace />, index: true },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'ordering',
          children: [
            { element: <Navigate to="/dashboard/ordering/orderList" replace />, index: true },
            { path: 'orderList', element: <OrderListPage /> },
            { path: 'orderGeneralList', element: <OrderGeneralListPage /> },
            { path: 'registrationOrder', element: <RegistrationOrderPage /> },
            { path: ':id', element: <OrderDetailPage /> },
            { path: ':id/view', element: <OrderGeneralDetailPage /> },
            { path: 'checkout', element: <CheckoutPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'payment',
          children: [
            { element: <Navigate to="/dashboard/payment/depositList" replace />, index: true },
            { path: 'depositList', element: <DepositListPage /> },
            { path: 'depositGeneralList', element: <DepositGeneralListPage /> },
            { path: ':id', element: <DepositRegistrationPage /> },
            { path: ':id/add', element: <DepositAddPage /> },
            { path: ':id/edit', element: <DepositConfirmPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'report',
          children: [
            {
              element: <Navigate to="/dashboard/report/onlineAccountBalance" replace />,
              index: true,
            },
            { path: 'onlineAccountBalance', element: <OnlineAccountBalancePage /> },
            { path: 'accountBalance', element: <AccountBalancePage /> },
            { path: 'averageReport', element: <AverageReportPage /> },
            { path: 'accountGeneralList', element: <AccountGeneralListPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'price',
          children: [
            { element: <Navigate to="/dashboard/price/supplyBoard" replace />, index: true },
            { path: 'supplyBoard', element: <SupplyBoardPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'financial',
          children: [
            { element: <Navigate to="/dashboard/financial/cifAccountList" replace />, index: true },
            { path: 'cifAccountList', element: <CifAccountPage /> },
            { path: 'manualAdd', element: <DepositManualACCT /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'transport',
          children: [
            { element: <Navigate to="/dashboard/transport/transportList" replace />, index: true },
            { path: 'transportList', element: <TransportPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        {
          path: 'mavad',
          children: [
            { element: <Navigate to="/dashboard/mavad/mavadgeneral" replace />, index: true },
            { path: 'mavadGeneral', element: <MavadGeneralPage /> },
            { path: 'mavad', element: <MavadPage /> },
            { path: 'mavadReport', element: <MavadReportPage /> },
            { path: 'mavadDeadStock', element: <MavadDeadStockPage /> },
            { path: ':idIN/edit', element: <MavadPage /> },
          ],
        },
        {
          path: 'tamink',
          children: [
            { element: <Navigate to="/dashboard/tamink/TaminkReport" replace />, index: true },
            { path: 'tamink', element: <TaminkPage /> },
            { path: ':idIN/edit', element: <TaminkPage /> },
            { path: 'taminkReport', element: <TaminkReportPage /> },
            { path: 'TaminkAll', element: <TaminkAllPage /> },
            { path: 'KharidReport', element: <KharidReportPage /> },
          ],
        },
        {
          path: 'SellM',
          children: [
            { element: <Navigate to="/dashboard/SellM/SellM" replace />, index: true },
            { path: 'SellM', element: <SellMPage /> },
            { path: 'SellAll', element: <SellAllPage /> },
            { path: 'SellTrend', element: <SellTrendPage /> },
            { path: 'SellByProduct', element: <SellByProductPage /> },
            { path: 'SellForecast', element: <SellForecastPage /> },
          ],
        },
        {
          path: 'CIFM',
          children: [
            { element: <Navigate to="/dashboard/CIFM/CIFM" replace />, index: true },
            { path: 'CIFRpt', element: <CIFRptPage /> },
            { path: 'CifAll', element: <CifAllPage /> },
            { path: 'CifCluster', element: <CifClusterPage /> },
            { path: 'CifProfile', element: <CifProfilePage /> },
            { path: 'CallRpt', element: <CallRptPage /> },
            { path: ':idIN/edit', element: <CifProfilePage /> },
          ],
        },
        {
          path: 'tolid',
          children: [
            { element: <Navigate to="/dashboard/tolid/tolidReport" replace />, index: true },
            { path: 'tolidReport', element: <TolidReportPage /> },
            { path: 'tolidGeneral', element: <TolidGeneralPage /> },
            { path: 'tolidTrend', element: <TolidTrendPage /> },
            { path: 'tolidTafkik', element: <TolidTafkikPage /> },
          ],
        },

        {
          path: 'ProductR',
          children: [
            { path: 'Product', element: <ProductPage /> },
            { path: 'ProductRpt', element: <ProductRptPage /> },
            { path: 'ProductD', element: <ProductDPage /> },
            { path: 'DeadstockProducts', element: <DeadstockProductsPage /> },
            { path: ':idIN/edit', element: <ProductDPage /> },

          ],
        },

        {
          path: 'Report',
          children: [
            { path: 'GlucAll', element: <GlucAllPage /> },

          ],
        },

        {
          path: 'HR',
          children: [
            { path: 'HRRpt', element: <HRRptPage /> },
            { path: 'HRProfile', element: <HRProfilePage /> },
            { path: ':idIN/edit', element: <HRProfilePage /> },
          ],
        },
        {
          path: 'BaseD',
          children: [
            { path: 'ProductList', element: <ProductListPage /> },
          ],
        },
        {
          path: 'logistics',
          children: [
            { path: 'trafficRpt', element: <TrafficRptPage /> },
            { path: 'taradodRpt', element: <TaradodRptPage /> },
            { path: 'vehicleList', element: <VehicleListPage /> },
            { path: 'vehicleCatList', element: <VehicleCatListPage /> },
            { path: 'vehicleD', element: <VehicleDPage /> },
            { path: ':pelak/edit', element: <VehicleDPage /> },
            { path: 'one', element: <PageOne /> },
          ],
        },
        // {
        //   path: 'xxxx',
        //   children: [
        //     { element: <Navigate to="/dashboard/xxxx/usersList" replace />, index: true },
        //     { path: 'usersList', element: <UsersListPage /> },
        //     { path: 'one', element: <PageOne /> },
        //   ],
        // },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '/', element: <Navigate to="/auth/login" replace /> },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
